import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';

var FINANCE_NAVIGATION_TYPE = {
  HOME: 'HOME',
  SAVINGS: 'SAVINGS',
  INSURANCE: 'INSURANCE',
  LOAN: 'LOAN',
  CARD: 'CARD'
};
var FINANCE_NAVIGATION_URL = {
  HOME: '/finance',
  SAVINGS: '/savings',
  INSURANCE: '/insurance',
  LOAN: '/loan',
  CARD: '/affiliate-card/home'
};
var FINANCE_NAVIGATION_TYPES = _Object$keys(FINANCE_NAVIGATION_TYPE);

export { FINANCE_NAVIGATION_TYPE, FINANCE_NAVIGATION_TYPES, FINANCE_NAVIGATION_URL };
